<template>
  <div class="dialog-login" v-if="show">
    <div class="login-box">
      <div class="lf">
        <img src="@/assets/login.png">
        <div class="l-info">
          <h3>欢迎来到汇读官网</h3>
          <h5>— 登录后即刻享受畅读体验！—</h5>
        </div>
      </div>
      <div class="ri">
        <span class="el-icon-error closeBtn" @click="hideLogin()"></span>
        <div class="tabs">
          <div class="t-item" :class="mode == 1 && 'active'" @click="change(1)">账号登录</div>
          <div class="t-item" :class="mode == 2 && 'active'" @click="change(2)">短信登录</div>
        </div>
        <el-form :model="model" :rules="rules" ref="form" class="ruleForm">
          <template v-if="mode == 1">
            <el-form-item prop="userName">
              <el-input v-model="model.userName" placeholder="请输入账号" class="ou-input">
                <i slot="prefix" class="icon iconfont icon-yonghu"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="passWord">
              <el-input v-model="model.passWord" placeholder="请输入密码" show-password class="ou-input">
                <i slot="prefix" class="icon iconfont icon-mima"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <span class="denluBtn" @click="submit()">登录</span>
            </el-form-item>
            <el-form-item>
              <span class="zuceBtn" @click="change(2)">立即注册</span>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item prop="userName">
              <el-input v-model="model.userName" placeholder="请输入手机号" class="ou-input"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-col :span="10">
                <el-input v-model="model.code" placeholder="验证码" class="ou-input"></el-input>
              </el-col>
              <el-col :span="13" :offset="1">
                <el-button @click="beforeSend()" type="default" class="ou-btn">
                  <template v-if="second == null">获取短信验证码</template>
                  <template v-else>重发<span>{{ second }}</span>s</template>
                </el-button>
              </el-col>
            </el-form-item>
            <el-form-item>
              <p class="tis-txt">* 未注册用户验证后将自动注册并登录</p>
              <span class="denluBtn" @click="submit()">登录 / 注册</span>
            </el-form-item>
          </template>
        </el-form>
        <template v-if="false">
          <div class="other-login">
            <div class="other-ti">其他登录方式</div>
            <div class="other-con">
              <div class="l-item">
                <div class="l-img"><img src="@/assets/carsi_blue@1x.png"></div>
                <div class="l-ti">CARSI登录</div>
              </div>
              <div class="l-item">
                <div class="l-img"><img src="@/assets/3560@1x.png"></div>
                <div class="l-ti">机构SSO登录</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <el-dialog title="请输入验证码" :visible.sync="dialogFormVisible"  width="25%" append-to-body :close-on-click-modal="false">
      <el-form :model="model">
        <el-form-item prop="CAPTCHA">
              <el-col :span="10">
                <el-input v-model="model.captcha" placeholder="" class="ou-input" @blur="vCheck"></el-input>
              </el-col>
              <el-col :span="13" :offset="1">
                  <img :src="captchaPath" @click="refreshCaptcha" alt=""/>
              </el-col>
            </el-form-item>
            <span v-if="isCheck" style="color: red;">请输入验证码</span>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible = false">取 消</el-button> -->
        <el-button class="captchaBtn" @click="checkCaptch">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import axios from 'axios';
export default {
  name: "Login",
  computed: {
    ...mapState({
      show: state => state.loginShow,
      mode: state => state.loginMode,
    })
  },
  data() {
    return {
      uuid:'',
      isCheck: false,
      dialogFormVisible:false,
      captchaPath: null,
      second: null,
      model: { userName: "", passWord: "", code: "" ,captcha:"",},
      rules: {
        userName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        passWord: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
    }
  },
  mounted() {
    console.log(JSON.parse(window.localStorage.org).id)
  },
  methods: {
    vCheck(){
      if(this.model.captcha){
        this.isCheck = false;
      }else{
        this.isCheck = true;
      }
    },
    checkCaptch(){
        if(this.model.captcha){
          this.$bti.checkCaptcha({ uuid: this.$com.getLocalStorageItem("captchaUUID"),captcha : this.model.captcha  }).then((res) => {
              if(res.code == 1){
                this.dialogFormVisible = false;
                this.send();
              }else{
                this.$message.error(res.info);
              }
          })
        }else{
          return;
        }
    },
    beforeSend(){
      var phone = this.model.userName;
      if (!phone) {
        this.$message.error("请输入手机号码");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message.error("手机号码格式不正确");
        return;
      }
      if (this.second != null && this.second != 0) {
        this.$message({ type: "error", message: "请勿重复发送" });
        return;
      }
      this.model.captcha = null;
      this.refreshCaptcha();
      this.dialogFormVisible = true
    },
   generateUUID() {
      this.$bti.captchaUUID().then((res) => {
        if(res.code == 1){
          this.$com.setLocalStorageItem("captchaUUID",res.data);
          this.uuid = res.data
          this.getCaptcha();
        }else{
          this.$message.error("获取图像验证码异常");
        }
      })
    },
    refreshCaptcha(){
      this.generateUUID();
    },
    getCaptcha(){
      axios({
        method: 'get',
        url: http.ipAddress+'Auth/captcha?uuid='+this.uuid,
        responseType: 'blob', // 重要：设置响应类型为blob
      }).then(response => {
        // 创建一个URL，引用保存图片内容的Blob对象
        this.captchaPath = URL.createObjectURL(new Blob([response.data]));
      }).catch(error => {
        console.error('图片加载失败:', error);
      });
    },
    change(mode) {
      if (mode == 1) {
        this.rules.userName[0].message = '请输入账号';
      } else {
        this.rules.userName[0].message = '请输入手机号';
      }
      this.$refs.form.resetFields();

      this.$store.commit('setLoginMode', mode);
      this.second = null;
    },
    submit() {
      var params = {
        port: "web",
        userName: this.model.userName
      };
      if (this.mode == 1) {
        params.mode = "account";
        params.passWord = this.model.passWord;
      }
      if (this.mode == 2) {
        params.mode = "sms";
        params.code = this.model.code;
        params.schoolId = JSON.parse(window.localStorage.org).id;
        params.captcha = this.model.captcha;
        params.captchaUUID = this.$com.getLocalStorageItem("captchaUUID");
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.$bti.Login(params).then((res) => {
          if (res.code != 1) {
            this.$message.error(res.info);
            return;
          }
          this.$com.login(res.data.token, this.$route.path);
        });
      });
    },
    send() {
      var phone = this.model.userName;
      if (!phone) {
        this.$message.error("请输入手机号码");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message.error("手机号码格式不正确");
        return;
      }
      if (this.second != null && this.second != 0) {
        this.$message({ type: "error", message: "请勿重复发送" });
        return;
      }
      this.$bti.GetSms({ tel: phone }).then((res) => {
        if (res.code != 1) {
          this.$message({ type: "error", message: res.info });
          return;
        }
        this.$message.success("短信发送成功");
        this.second = 60;
        var interval = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            this.second = null
            clearInterval(interval);
          }
        }, 1000);
      });
    },
    hideLogin() {
      this.$com.hideLogin();
    },
  },
}
</script>


<style lang="css" scoped>
.dialog-login,
.login-box,
.tabs,
.other-login,
.other-con {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
}

.dialog-login {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  width: 100%;
  height: 100%;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.inner-login {
  width: 533px;
  height: 373px;
  border-radius: 10px;
  padding: 10px;
  overflow: hidden;
  position: relative;
}

.dialog-login:before {
  position: absolute;
  content: '';
  left: 0;
  top: 0;
  z-index: 112;
  background-color: rgb(0, 0, 0);
  opacity: .5;
  width: 100%;
  height: 100%;
}

.login-box {
  position: relative;
  z-index: 113;
  background-color: #fff;
  border-radius: 10px;
  width: 513px;
  height: 353px;
  overflow: hidden;
}

.login-box .lf {
  position: relative;
  width: 215px;
  height: 100%;
  border-bottom-left-radius: 10px;
}

.login-box .lf img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-box .lf .l-info {
  position: absolute;
  left: 0;
  top: 15px;
  text-align: center;
  line-height: 1.8;
  width: 100%;
}

.login-box .lf .l-info h3 {
  font-weight: bold;
  font-size: 14px;
}

.login-box .lf .l-info h5 {
  font-size: 10px;
}

.login-box .ri {
  width: calc(100% - 215px);
  padding: 10px 30px;
  position: relative;
}

.login-box .ri .closeBtn {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1111;
  color: #B8B8B8;
  font-size: 25px;
  cursor: pointer;
}

.tabs {
  border-bottom: 1px solid #F3F5F7;
  color: #A8A8A8;
  line-height: inherit;
  height: inherit;
  margin-bottom: 15px;
}

.tabs .t-item {
  padding: 0 15px;
  cursor: pointer;
}

.tabs .t-item.active {
  color: #3C9B9E;
  font-weight: bold;
  border-bottom: 2px solid #3C9B9E;
}

.captchaBtn{
  background-color: #3C9B9E;
  color: #fdfdfd;
  border-radius: 6px;
}

.denluBtn {
  display: block;
  width: 100%;
  height: 35px;
  line-height: 35px;
  background-color: #3C9B9E;
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
}

.zuceBtn {
  display: block;
  width: 100%;
  text-align: center;
  cursor: pointer;
  color: #3C9B9E;
  height: auto;
  line-height: normal;
  text-decoration: underline;
}

.other-ti {
  color: #A8A8A8;
  font-size: 10px;
}

.other-con {
  padding-left: 15px;
}

.other-con .l-item {
  text-align: center;
  cursor: pointer;
}

.other-con .l-item:nth-child(1) {
  margin-right: 15px;
}

.other-con .l-item .l-img {
  width: 30px;
  height: 30px;
  background-color: #F3F5F7;
  border-radius: 100%;
  padding: 3px;
  line-height: normal;
  margin: 0px auto;
}

.other-con .l-item .l-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.other-con .l-item .l-ti {
  color: #272636;
  font-size: 10px;
  white-space: nowrap;
  line-height: normal;
  padding-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/common/login/Login.vue